// 売り切れ表示、購入フォームの代わりに表示される

export const Soldout = () => {
  return (
    <div className="p-4">
      <button
        className="w-full text-base rounded-lg text-center relative font-bold p-4 bg-[#444] text-white"
        disabled
      >
        売り切れ
      </button>
    </div>
  )
}
